/**
 * @generated SignedSource<<8e0f5b6b67b3bb9f201a8d6b46795a1d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_viewer" | "ProductImageCarousel_viewer">;
  readonly " $fragmentType": "BuyerProductCarousel_viewer";
};
export type BuyerProductCarousel_viewer$key = {
  readonly " $data"?: BuyerProductCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImageCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1466e88b099da8ca829096d294f74f0e";

export default node;
